import type { SipPlansCategory, SipIncreaseRecommendation } from '../../../../api/sipPlan.types'
import { SipCategoryBucketKey, SIP_CATEGORY_BUCKET_TITLES, SipPlanMode, type SipActionFilter } from '../../../../api/types'
import { useSipPlanCategoryBucket } from '../../../usePlanCategoryBucketExpansion'
import { BucketAccordion } from '../../../../../lumpsum/plans-list/lumpsum-ui-components/BucketAccordion'
import { IncreaseSipFundCard } from '../cards/IncreaseSipFundCard'
import { getCategoryBucketItems } from '../../../../../utils/categoryBucketsUtils'
import { EventNames } from '../../../../../../../../types/misc.types'
import { trackEvent } from '../../../../../../../../utils/appBridge'
import { PlansScreen, PlansSipListEventIds } from '../../../../../analytics/plansEvents'

type IncreaseSipBucketAccordionProps = {
  category: SipPlansCategory
  categoryId: string
  actionFilter: SipActionFilter
  isBorderTop?: boolean
}

export function IncreaseSipBucketAccordion({
  category,
  categoryId,
  actionFilter,
  isBorderTop = false
}: IncreaseSipBucketAccordionProps) {
  const increaseRecommendations = getCategoryBucketItems<SipIncreaseRecommendation>(category?.increaseRecommendations)
  const { bucketCompositeKey, isExpanded, toggle } = useSipPlanCategoryBucket({
    planMode: SipPlanMode.YOUR_PLAN,
    actionFilter,
    categoryId,
    bucketKey: SipCategoryBucketKey.increaseRecommendations
  })

  return (
    <BucketAccordion
      bucketCompositeKey={bucketCompositeKey}
      title={SIP_CATEGORY_BUCKET_TITLES[SipCategoryBucketKey.increaseRecommendations]}
      count={increaseRecommendations.length}
      isExpanded={isExpanded}
      onToggle={() => {
        trackEvent({
          eventName: EventNames.UserClicked,
          payload: {
            ScreenName: PlansScreen.SipYourPlan,
            eventId: PlansSipListEventIds.BucketAccordion,
            buttonLabel: SIP_CATEGORY_BUCKET_TITLES[SipCategoryBucketKey.increaseRecommendations]
          }
        })
        toggle()
      }}
      isBorderTop={isBorderTop}
    >
      {increaseRecommendations.map((recommendation, recommendationIndex) => (
        <IncreaseSipFundCard
          key={`${recommendation?.isin ?? 'fund'}-${recommendationIndex}`}
          recommendation={recommendation}
          showBottomDivider={recommendationIndex < increaseRecommendations.length - 1}
        />
      ))}
    </BucketAccordion>
  )
}
